export function getIntercomAppId() {
  return (import.meta.env.VITE_INTERCOM_APP_ID || "").trim()
}

export function canUseIntercomMessenger() {
  return Boolean(getIntercomAppId())
}

export function openIntercomMessenger() {
  return callIntercom("show")
}

export function shutdownIntercomMessenger() {
  if (callIntercom("shutdown")) {
    return true
  }

  clearIntercomCookies(getIntercomAppId())
  return false
}

function callIntercom(method: string) {
  if (typeof window === "undefined") {
    return false
  }

  const intercom = (window as Window & { Intercom?: (method: string) => void }).Intercom
  if (typeof intercom !== "function") {
    return false
  }

  intercom(method)
  return true
}

function clearIntercomCookies(appId: string) {
  if (typeof document === "undefined" || !appId) {
    return
  }

  const appCookieSuffix = `-${appId}`
  for (const cookie of document.cookie.split(";")) {
    const cookieName = cookie.split("=")[0]?.trim()
    if (!cookieName?.startsWith("intercom-") || !cookieName.endsWith(appCookieSuffix)) {
      continue
    }

    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
  }
}
